import Axios from 'config/service.config'
import envConfig from 'config/env_config'

export const redirectService = async (isThermAccepted, pageRedirect) => {
  try {
    const { data } = await Axios({
      baseURL: envConfig.user,
      url: '/integration/redirect',
      method: 'post',
      withCredentials: true,
      data: {
        isThermAccepted,
        pageRedirect
      }
    })
    return data
  } catch (error) {
    return {
      redirect: pageRedirect
    }
  }
}
